import { render, staticRenderFns } from "./EventAdmin.vue?vue&type=template&id=80563400"
import script from "./EventAdmin.js?vue&type=script&lang=js&external"
export * from "./EventAdmin.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports